import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import BottomRowButton from './blocks/bottomRowButton';
import ImportedFileMoreRows from './blocks/importedFileMoreRows';
import RightClickMenu from './blocks/rightClickMenu';
import StepProcess from './blocks/stepProcess';
import NotStenaTemplateDialog from './blocks/notStenaTemplateDialog';
import Instructions from './blocks/instructions';

import UploadFile from './steps/uploadFile';
import RenderImportedFile from './steps/renderImportedFile';
import CabinDistributor from './steps/cabin/cabinDistributor';
import Done from './steps/done';

import './importFile.css';

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  display:flex;
  align-items:center;
  justify-content:center;
  top:0;
  left:0;
  background:rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const InnerModal = styled.div`
  display:flex;
  position: relative;
  align-items:center;
  justify-content:center;
  flex-direction: column;
  min-width: 960px;
  max-width: 1650px;
  width: 100%;
  height: 75%;
  background: rgba(255, 255, 255, 1);
`;

const TopInnerModal = styled.div`
  position:relative;
  display:flex;
  align-items:center;
  justify-content:space-between;
  width: 100%;
  height: 10%;
  background: #fff;
  border-bottom: 2px solid #eee;
  z-index:1000;
  padding: 10px 0px;
`;

const ImportFileTitle = styled.div`
  display:flex;
  align-items:center;
  justify-content:flex-start;
  width: 70%;
  height: 100%;
  font-size: 32px;
  color: #335B80;
  padding-left: 45px;
`;

const ShowImportedFile = styled.div`
  display:flex;
  align-items:flex-start;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction:column;
  width: 100%;
  min-width:100%;
  height: 90%;
  background:rgba(255, 255, 255, 1);
  padding: 0px;
`;

const BottomInnerModal = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  position:relative;
  width: 100%;
  height: 10%;
  background: #ecf2f8;
  padding: 10px 0px;
`;

const InstructionsContainer = styled.div`
  display:flex;
  align-items:center;
  justify-content:flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

class ImportModal extends React.Component {

  constructor() {
    super();
    this.state = {
      rightClickMenuActive: false,
      rightClickMenuXPos: 0,
      rightClickMenuYPos: 0,
      pastedText: '',
    };
  }

  onImportedFileAreaRightClick = (e) => {
    const X = e.nativeEvent.offsetX;
    const Y = e.nativeEvent.offsetY;
    this.setState({
      rightClickMenuActive: true,
      rightClickMenuXPos: X,
      rightClickMenuYPos: Y,
    });
    e.preventDefault();
  }

  getAppText = string => Object.keys(this.props.appTextsForImportFile).map(key => (key === string ? this.props.appTextsForImportFile[key] : null)).filter(a => a).toString() || 'UNDEFINED';

  closeRightClickMenu = () => {
    if (this.state.rightClickMenuActive) {
      this.setState({ rightClickMenuActive: false });
    }
  }

  clickOnItemInRightMenu = (item) => {
    if (item === 'paste') {
      this.pasteDataFromClipboard();
    }
    this.setState({
      rightClickMenuActive: false,
      rightClickMenuXPos: 0,
      rightClickMenuYPos: 0,
    });
  };

  pasteDataFromClipboard = (event) => {
    this.formatPastedText(event.clipboardData.getData('Text') || '');
  };

  formatPastedText = (text) => {
    const { setImportFile, makeid, stepBackAndForthInProcessImportedFile, appTexts } = this.props;
    const findLineBreaksInText = text.split('\n');
    const findTabsInText = findLineBreaksInText.map(text => text.split('\t').filter(t => t.length));
    findTabsInText.splice(0, 0, findTabsInText[0]);
    const formatToImport = findTabsInText.map((text, index) =>
      text.map((t) => {
        if (index === 0) {
          const getSpecificApptext = appTexts && appTexts.filter(apptext => Object.keys(apptext).toString().toLowerCase() === t.replace(/ +/g, '').toLowerCase());
          const getApptext = getSpecificApptext.map(t => Object.values(t)).toString();
          const getAppname = getSpecificApptext.map(t => Object.keys(t)).toString();
          const object = { name: getAppname.length > 0 ? getAppname : null, text: getApptext.length > 0 ? getApptext : null, titleRow: true, id: makeid() };
          return object;
        }
        return { value: t, id: makeid() };
      }),
    ).filter(row => row.length);
    formatToImport.id = makeid();
    const formatToImportWithId = [];
    formatToImport.map((obj) => {
      const o = obj;
      o.id = makeid();
      return formatToImportWithId.push(o);
    });
    let newState = null;
    newState = update(this.state, {
      formattedFile: { $set: formatToImport },
    });
    newState.formattedFile.id = makeid();
    setImportFile(newState);
    stepBackAndForthInProcessImportedFile(1);
  };

  displayRemoveCheckedNumbers = (checkedRows) => {
    const sortedRow = checkedRows.sort((a, b) => a - b);
    const a = [];
    sortedRow.map((s, i) => {
      if (i === 0 && sortedRow[i + 2] === s + 2) {
        a[s - 1] = true;
        return true;
      }
      if ((sortedRow[i + 1] === s + 1 && sortedRow[i - 1] === s - 1)) {
        a[s - 1] = true;
        return true;
      }
      if ((sortedRow[i + 1] === s + 1 && sortedRow[i + 2] === s + 2 && sortedRow[i - 1] !== s - 1) || (sortedRow[i - 1] === s - 1 && sortedRow[i - 2] === s - 2 && sortedRow[i + 1] !== s + 1)) {
        a[s - 1] = true;
        return true;
      }
      a[s - 1] = false;
      return false;
    });
    return sortedRow.map((s) => {
      const b = s - 1;
      if (!a[b]) {
        return <li className="checked-numbers-single" key={s}>{s}</li>;
      }
      if ((a[b] && !a[b - 1])) {
        return <li className="checked-numbers-before" key={s}>{s}</li>;
      }
      if (a[b] && a[b - 1] && a[b + 1]) {
        return null;
      }
      return <li className="checked-numbers-after" key={s}>{s}</li>;
    });
  }

  stepProcess = () => {
    const { cabindIds, importedFileTitleRow } = this.props;
    const isCabinChoosenInDropdown = importedFileTitleRow.some(title => title && title.name === 'cabin');
    const steps = [
      { stepName: this.getAppText('stepProcessUploadFileText'), id: 'uploadFile' },
      { stepName: this.getAppText('stepProcessChooseColumnText'), id: 'chooseColumn' },
      { stepName: this.getAppText('stepProcessRemoveRowsText'), id: 'removeRows' },
      { stepName: this.getAppText('stepProcessCompleteText'), id: 'completeText' },
    ];
    const cabin = { stepName: this.getAppText('stepProcessCabinText'), id: 'cabinText' };
    if (cabindIds.length && isCabinChoosenInDropdown) {
      steps.splice(3, 0, cabin);
    }
    return steps;
  };

  formatApptexts = () => {
    const { appTexts, mandatoryBirthdate, cabindIds, importedFileTitleRow } = this.props;
    let newAppTexts = appTexts;
    if (!mandatoryBirthdate) {
      newAppTexts = newAppTexts.filter(a => Object.keys(a)[0].toLowerCase() !== 'dateofbirth');
    }
    if (cabindIds && cabindIds.length <= 0) {
      newAppTexts = newAppTexts.filter(a => Object.keys(a)[0].toLowerCase() !== 'cabin');
    }
    const getSelectedDropdownTitles = importedFileTitleRow.filter(i => i);
    if (getSelectedDropdownTitles.length) {
      newAppTexts = newAppTexts.filter((el) => {
        const name = Object.keys(el).toString().toLowerCase();
        if (getSelectedDropdownTitles && getSelectedDropdownTitles.map(title => title.name && title.name.toLowerCase()).includes(name)) {
          return null;
        }
        return el;
      });
    }
    const reFormatNewApptext = newAppTexts.map(a => ({ name: Object.keys(a).toString(), text: Object.values(a).toString() }));
    return reFormatNewApptext;
  };

  render() {
    const {
      reservationCode,
      handleImportedFile,
      formattedFile,
      onToggleModal,
      setCorrectColumnToCorrectTitle,
      removeCorrectColumnToCorrectTitle,
      importedFileTitleRow,
      onDoneImportFileClick,
      onRemoveImportFileClick,
      appTexts,
      titleOnColumnNumber,
      importedFileHasMoreRowsThanGuests,
      // mandatoryBirthdate,
      cabindIds,
      rowIsActive,
      checkedRows,
      importedFileActiveStep,
      stepBackAndForthInProcessImportedFile,
      cabinData,
      setActiveCabinForImportedFileCabinDistributor,
      setActivePersonForImportedFileCabinDistributor,
      activeCabinInCabinDistributor,
      activePersonInCabinDistributor,
      personsLinkedToCabin,
      cabinsOut,
      cabinsHome,
      showStenaTemplateDialog,
      onClickContinueWithImportNotStenaTemplate,
      onClickImportNewFileNotStenaTemplate,
      isBirthDateMandatory,
      removePersonFromPersonsLinkedToCabinImportedFile,
      allRemainingCabinsIdsWithoutGuests,
      routeNameOut,
      routeNameHome,
      getRemainingBeds,
      } = this.props;
    const isCabinChoosenInDropdown = importedFileTitleRow.some(title => title && title.name === 'cabin');
    const lastStepInStepProcess = cabindIds.length && isCabinChoosenInDropdown ? 4 : 3;
    const { rightClickMenuActive, rightClickMenuXPos, rightClickMenuYPos } = this.state;
    const disableRemoveButton = formattedFile.length === 0 || importedFileActiveStep !== 2 || showStenaTemplateDialog || checkedRows.length <= 0;
    const disableNextButton = (
      (titleOnColumnNumber.filter(title => title && title.name).length === 0 && importedFileActiveStep === 1)
      || formattedFile.length === 0
      || importedFileActiveStep === lastStepInStepProcess
      || showStenaTemplateDialog
      || (importedFileActiveStep === 2 && checkedRows.length > 0)
      || (Object.keys(importedFileHasMoreRowsThanGuests).length > 0 && importedFileActiveStep === 2)
      );
    const disablePreviousButton = formattedFile.length === 0 || importedFileActiveStep === 0 || showStenaTemplateDialog || (importedFileActiveStep === 2 && checkedRows.length > 0);
    return (
      <Container>
        <InnerModal id="import-file-inner-modal" onClick={() => this.closeRightClickMenu()}>
          <TopInnerModal>
            <ImportFileTitle>
              {this.getAppText('headerTitle')}
            </ImportFileTitle>
            <div className="imported-file-close" tabIndex={0} role="button" onClick={() => onToggleModal()}><span /></div>
          </TopInnerModal>
          {Object.keys(importedFileHasMoreRowsThanGuests).length > 0 && importedFileActiveStep === 2
          ? <ImportedFileMoreRows
            importedFileHasMoreRowsThanGuests={importedFileHasMoreRowsThanGuests}
            moreRowsThanGuestsTitle={this.getAppText('moreRowsThanGuestsTitle')}
            moreRowsThanGuestsInImportedFile={this.getAppText('moreRowsThanGuestsInImportedFile')}
            moreRowsThanGuestsInReservation={this.getAppText('moreRowsThanGuestsInReservation')}
          />
          : null
          }
          <ShowImportedFile id="show-imported-file">
            {importedFileActiveStep === 0 && !showStenaTemplateDialog ?
              <UploadFile
                textTitle={this.getAppText('uploadFileTitle')}
                textExplanation={this.getAppText('uploadFileExplanationText')}
                buttonTitle={this.getAppText('uploadButton')}
                copyPasteTitle={this.getAppText('copyPasteTitle')}
                copyPasteExplanation={this.getAppText('copyPasteExplanation')}
                copyPastePlaceholder={this.getAppText('copyPastePlaceholder')}
                downloadTemplateTitle={this.getAppText('downloadTemplateTitle')}
                handleImportedFile={handleImportedFile}
                pasteDataFromClipboard={this.pasteDataFromClipboard}
                appTexts={appTexts}
                reservationCode={reservationCode}
                isBirthDateMandatory={isBirthDateMandatory}
                cabindIds={cabindIds}
              />
            : null}
            {importedFileActiveStep === 0 && showStenaTemplateDialog ?
              <NotStenaTemplateDialog
                title={this.getAppText('notStenaTemplateTitle')}
                explanation={this.getAppText('notStenaTemplateExplanation')}
                uploadNewFileTitle={this.getAppText('notStenaTemplateUploadNewFileTitle')}
                continueText={this.getAppText('notStenaTemplateContinueText')}
                onClickContinueWithImportNotStenaTemplate={onClickContinueWithImportNotStenaTemplate}
                onClickImportNewFileNotStenaTemplate={onClickImportNewFileNotStenaTemplate}
              />
              : null
            }
            {formattedFile.length && (importedFileActiveStep === 1 || importedFileActiveStep === 2) ?
              <InstructionsContainer>
                {importedFileActiveStep === 1
                ? <Instructions
                  title={this.getAppText('chooseColumnTitle')}
                  explanation={this.getAppText('chooseColumnExplanation')}
                  importedFileActiveStep={importedFileActiveStep}
                />
                : <Instructions
                  title={this.getAppText('removeDataTitle')}
                  explanation={this.getAppText('removeDataExplanation')}
                  importedFileActiveStep={importedFileActiveStep}
                />
                }
                <RenderImportedFile
                  importedFileTitleRow={importedFileTitleRow}
                  formattedFile={formattedFile}
                  setCorrectColumnToCorrectTitle={setCorrectColumnToCorrectTitle}
                  removeCorrectColumnToCorrectTitle={removeCorrectColumnToCorrectTitle}
                  drag={this.drag}
                  preventDrop={this.preventDrop}
                  dragEnd={this.dragEnd}
                  placeholder={this.getAppText('chooseColumnPlaceholder')}
                  removeDatRemoveRowTitle={this.getAppText('removeDataTextRemoveRow')}
                  rowIsActive={rowIsActive}
                  checkedRows={checkedRows}
                  formatApptexts={this.formatApptexts()}
                  importedFileActiveStep={importedFileActiveStep}
                />
              </InstructionsContainer>
              : null}
            {formattedFile.length && importedFileActiveStep === 3 && cabindIds.length && isCabinChoosenInDropdown ?
              <CabinDistributor
                importedFileTitleRow={importedFileTitleRow}
                formattedFile={formattedFile}
                cabinData={cabinData}
                setActiveCabinForImportedFileCabinDistributor={setActiveCabinForImportedFileCabinDistributor}
                setActivePersonForImportedFileCabinDistributor={setActivePersonForImportedFileCabinDistributor}
                activeCabinInCabinDistributor={activeCabinInCabinDistributor}
                activePersonInCabinDistributor={activePersonInCabinDistributor}
                personsLinkedToCabin={personsLinkedToCabin}
                cabinsHome={cabinsHome}
                cabinsOut={cabinsOut}
                removePersonFromPersonsLinkedToCabinImportedFile={removePersonFromPersonsLinkedToCabinImportedFile}
                allRemainingCabinsIdsWithoutGuests={allRemainingCabinsIdsWithoutGuests}
                cabinInstructionList={this.getAppText('cabinInstructionList')}
                cabinsAllocatedInfo={this.getAppText('cabinsAllocatedInfo')}
                selectCabinInfoCompleteDescription={this.getAppText('selectCabinInfoCompleteDescription')}
                selectCabinInfoEmptyDescription={this.getAppText('selectCabinInfoEmptyDescription')}
                selectCabinInfoErrorDescription={this.getAppText('selectCabinInfoErrorDescription')}
                selectCabinInfoHeading={this.getAppText('selectCabinInfoHeading')}
                selectCabinInfoParagraph={this.getAppText('selectCabinInfoParagraph')}
                selectCabinInfoSelectCabin={this.getAppText('selectCabinInfoSelectCabin')}
                selectCabinInfoStartedDescription={this.getAppText('selectCabinInfoStartedDescription')}
                filterTabAvailableCabins={this.getAppText('filterTabAvailableCabins')}
                filterTabFullCabins={this.getAppText('filterTabFullCabins')}
                cabinDistributionDone={this.getAppText('cabinDistributionDone')}
                routeNameOut={routeNameOut}
                routeNameHome={routeNameHome}
                getRemainingBeds={getRemainingBeds}
              />
            : null}
            {importedFileActiveStep === lastStepInStepProcess ?
              <InstructionsContainer>
                <Instructions
                  title={this.getAppText('uploadCompleteTitle')}
                  explanation={this.getAppText('uploadCompleteExplanationText')}
                  importedFileActiveStep={importedFileActiveStep}
                />
                <Done
                  buttonTitle={this.getAppText('doneButton')}
                  doneImportText={this.getAppText('doneImportText')}
                  onDoneImportFileClick={onDoneImportFileClick}
                  personsLinkedToCabin={personsLinkedToCabin}
                  importedFileHasMoreRowsThanGuests={importedFileHasMoreRowsThanGuests}
                  formattedFile={formattedFile}
                  importedFileTitleRow={importedFileTitleRow}
                  cabinsOut={cabinsOut}
                  cabinsHome={cabinsHome}
                  isCabinChoosenInDropdown={isCabinChoosenInDropdown}
                  importFileDoneGuestsText={this.getAppText('importFileDoneGuestsText')}
                  importFileDoneGuestToImportText={this.getAppText('importFileDoneGuestToImportText')}
                  importFileDoneCabinOutText={this.getAppText('importFileDoneCabinOutText')}
                  importFileDoneCabinHomeText={this.getAppText('importFileDoneCabinHomeText')}
                  importFileDoneGuestTotalText={this.getAppText('importFileDoneGuestTotalText')}
                />
              </InstructionsContainer>
            : null}
            {rightClickMenuActive ?
              <RightClickMenu pasteText={this.getAppText('rightClickMenuPaste')} clickOnItemInRightMenu={this.clickOnItemInRightMenu} rightClickMenuXPos={rightClickMenuXPos} rightClickMenuYPos={rightClickMenuYPos} />
            : null}
          </ShowImportedFile>
          <BottomInnerModal>
            <BottomRowButton
              title={this.getAppText('backButton')}
              type="previous"
              disabled={disablePreviousButton}
              onClickButton={() => stepBackAndForthInProcessImportedFile(importedFileActiveStep - 1)}
            />
            <StepProcess importStepProcess={this.stepProcess()} importedFileActiveStep={importedFileActiveStep} />
            <BottomRowButton
              title={this.getAppText('removeButton')}
              type="remove"
              disabled={disableRemoveButton}
              onClickButton={() => onRemoveImportFileClick(appTexts, importedFileTitleRow)}
              checkedRows={this.displayRemoveCheckedNumbers(checkedRows)}
            />
            <BottomRowButton
              title={this.getAppText('nextButton')}
              type="next"
              disabled={disableNextButton}
              onClickButton={() => stepBackAndForthInProcessImportedFile(importedFileActiveStep + 1)}
            />
          </BottomInnerModal>
        </InnerModal>
      </Container>
    );
  }
}

ImportModal.propTypes = {
  reservationCode: PropTypes.string,
  onToggleModal: PropTypes.func.isRequired,
  handleImportedFile: PropTypes.func,
  formattedFile: PropTypes.array,
  setCorrectColumnToCorrectTitle: PropTypes.func,
  removeCorrectColumnToCorrectTitle: PropTypes.func,
  makeid: PropTypes.func,
  importedFileTitleRow: PropTypes.array,
  onDoneImportFileClick: PropTypes.func,
  onRemoveImportFileClick: PropTypes.func,
  appTexts: PropTypes.array,
  appTextsForImportFile: PropTypes.object,
  titleOnColumnNumber: PropTypes.array,
  importedFileHasMoreRowsThanGuests: PropTypes.object,
  mandatoryBirthdate: PropTypes.bool,
  cabindIds: PropTypes.array,
  setImportFile: PropTypes.func,
  rowIsActive: PropTypes.func,
  checkedRows: PropTypes.array,
  importStepProcess: PropTypes.array,
  importedFileActiveStep: PropTypes.number,
  stepBackAndForthInProcessImportedFile: PropTypes.func,
  cabinData: PropTypes.array,
  setActiveCabinForImportedFileCabinDistributor: PropTypes.func,
  setActivePersonForImportedFileCabinDistributor: PropTypes.func,
  activeCabinInCabinDistributor: PropTypes.string,
  activePersonInCabinDistributor: PropTypes.string,
  personsLinkedToCabin: PropTypes.array,
  cabinsOut: PropTypes.array,
  cabinsHome: PropTypes.array,
  showStenaTemplateDialog: PropTypes.bool,
  onClickContinueWithImportNotStenaTemplate: PropTypes.func,
  onClickImportNewFileNotStenaTemplate: PropTypes.func,
  removePersonFromPersonsLinkedToCabinImportedFile: PropTypes.func,
  isBirthDateMandatory: PropTypes.bool,
  allRemainingCabinsIdsWithoutGuests: PropTypes.array,
  routeNameOut: PropTypes.string,
  routeNameHome: PropTypes.string,
  getRemainingBeds: PropTypes.number,
};

export default ImportModal;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/importModal.js